export const userAccountsEntityName = 'userAccounts'

export interface UserAccountsEntity {
  uuid: string
  phone_number: string
  email: string
  first_name: string
  last_name: string
  campaigns: Array<{ name: string; url_name: string }>
  client_account_invites: string[]
  client_accounts: Array<{ uuid: string; name: string }>
  client_accounts_count: number
  client_accounts_type: string
  email_verified_state: string
  is_distributor: boolean
  is_staff: boolean
  is_superuser: boolean
  mfa_enabled: boolean
  is_active: boolean
  is_email_unsubscribed: boolean
}
